// src/components/chat/EmojiPicker.jsx
// Picker de emojis simple sin dependencias externas. Lista curada por categorías
// (suficiente para chat interno; si se quiere full Unicode, sustituir por
// emoji-picker-react o similar — son ~70 KB extra al bundle).
import React, { useEffect, useRef, useState } from 'react';

const CATEGORIES = [
    {
        name: 'Caras',
        emojis: ['😀','😁','😂','🤣','😊','😍','😘','😎','🤩','🤔','😐','😴','🤤','😪','🥱','😅','😆','🙃','🙂','😉','😇','🥰','😋','😛','🤗','🤭','😬','😏','😶','🙄','😤','😡','😱','🤯','😢','😭','😩','😓','😔','😟','🤒','🤕','🤧','😷','🥺','🫡','🫠','🫢','🫣'],
    },
    {
        name: 'Gestos',
        emojis: ['👍','👎','👌','✌️','🤞','🤝','👏','🙏','🙌','💪','🫶','🫰','🤘','🤙','👋','🤚','✋','🖐️','🖖','👈','👉','👆','👇','☝️','🫵','🤌','🫳','🫴'],
    },
    {
        name: 'Símbolos',
        emojis: ['❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💖','💗','💘','💝','💯','✅','❌','⚠️','❓','❗','‼️','🔥','💧','✨','⭐','🌟','💫','🎉','🎊','🎁','🎂','🏆','🥇','🥈','🥉'],
    },
    {
        name: 'Trabajo',
        emojis: ['💼','📁','📂','🗂️','📋','📝','✏️','🖊️','📌','📎','📅','📆','🗓️','⏰','⏳','📞','☎️','💻','🖥️','⌨️','🖱️','🖨️','📧','📨','📬','📤','📥','📊','📈','📉','📑','💡','🔔','🔕','🔒','🔓','🔑'],
    },
];

export default function EmojiPicker({ onPick, onClose }) {
    const [tab, setTab] = useState(0);
    const ref = useRef(null);

    useEffect(() => {
        const onClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) onClose?.();
        };
        const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
        document.addEventListener('mousedown', onClickOutside);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onClickOutside);
            document.removeEventListener('keydown', onKey);
        };
    }, [onClose]);

    return (
        <div
            ref={ref}
            style={{
                position: 'absolute',
                bottom: 'calc(100% + 8px)',
                left: 0,
                width: 320,
                maxHeight: 280,
                background: 'var(--c-card, #fff)',
                border: '1px solid var(--c-border, #e5e7eb)',
                borderRadius: 10,
                boxShadow: '0 8px 24px rgba(0,0,0,.15)',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                zIndex: 1000,
            }}
        >
            <div style={{ display: 'flex', borderBottom: '1px solid var(--c-border, #e5e7eb)' }}>
                {CATEGORIES.map((c, i) => (
                    <button
                        key={c.name}
                        type="button"
                        onClick={() => setTab(i)}
                        style={{
                            flex: 1,
                            padding: '6px 4px',
                            border: 'none',
                            background: i === tab ? 'rgba(37,99,235,.08)' : 'transparent',
                            color: i === tab ? '#2563eb' : 'var(--c-text-3, #475569)',
                            fontSize: 11,
                            fontWeight: 600,
                            cursor: 'pointer',
                        }}
                    >
                        {c.name}
                    </button>
                ))}
            </div>
            <div style={{
                flex: 1,
                overflowY: 'auto',
                padding: 8,
                display: 'grid',
                gridTemplateColumns: 'repeat(8, 1fr)',
                gap: 2,
            }}>
                {CATEGORIES[tab].emojis.map((e, i) => (
                    <button
                        key={`${tab}-${i}`}
                        type="button"
                        onClick={() => onPick?.(e)}
                        title={e}
                        style={{
                            border: 'none',
                            background: 'transparent',
                            fontSize: 22,
                            lineHeight: '32px',
                            height: 32,
                            cursor: 'pointer',
                            borderRadius: 4,
                        }}
                        onMouseEnter={(ev) => ev.currentTarget.style.background = 'rgba(0,0,0,.06)'}
                        onMouseLeave={(ev) => ev.currentTarget.style.background = 'transparent'}
                    >
                        {e}
                    </button>
                ))}
            </div>
        </div>
    );
}
